import { create } from 'zustand';

interface VolunteersState {
  setViewedVolunteers: (id: string) => void;
  viewedVolunteers: string[];
}

export const useVolunteersStore = create<VolunteersState>()((set) => ({
  viewedVolunteers: [],
  setViewedVolunteers: (id: string) =>
    set(({ viewedVolunteers }) => ({ viewedVolunteers: [...viewedVolunteers, id] })),
}));
